export default "__VITE_ASSET__dKYf5z8___"